import { Component, EventEmitter, Output } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator
} from '@angular/forms';

@Component({
  selector: 'app-input-pesquisar',
  templateUrl: './input-pesquisar.component.html',
  styleUrls: ['./input-pesquisar.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: InputPesquisarComponent
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: InputPesquisarComponent
    }
  ]
})
export class InputPesquisarComponent
  implements ControlValueAccessor, Validator
{
  private _value: string;

  public get value(): string {
    return this._value;
  }

  public set value(v: string) {
    this._value = v;
    this.onChange(v);
  }

  @Output() buscar = new EventEmitter();
  touched = false;
  disabled = false;
  onChange: (newValue: string) => void = () => {};
  onTouched: () => void = () => {};
  onValidatorChanges: () => void = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  tocar() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(): ValidationErrors | null {
    return null;
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidatorChanges = fn;
  }
}
